module.exports = __webpack_public_path__ + "static/pic05-317040084f1feedc3adf1c4087b710e9.jpg";